(function(w) {
  w.Kinougarde = Object.assign({},w.Kinougarde, { JeuxConcours : {}});
  /**
     * Initialisation du formulaire
     */
  w.Kinougarde.JeuxConcours.initFormulaireJeuxConcours = function() {        
              
    var idCandidature= null;    

    // Valeur par défaut du formulaire        
    var dataJeuxConcours = Kinougarde.GetStorage("form-jeux-concours");
    Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : dataJeuxConcours});

    // Capte le résultat de l'action ajax est_desservie_jeux_concours sur l'étape "Coordonnées"        
    jQuery("#step_coordonnees").on("form-step-next-changed", function(e,reponse,data) {           
      Kinougarde.JeuxConcours.toogleEstDesservie(reponse.data);           
    });
    
    // Capte le click sur la case à cocher "Je souhaite être contacté pour un devis"
    jQuery("#devis").on('click',function() {
      // Affiche/Masuqe le numéro de téléphone
      jQuery("#group-telephone").toggleClass('hidden');
      // Active/Désactive la validation (champ obligatoire) pour le téléphone
      if (!jQuery("#group-telephone").hasClass("hidden")) {        
        jQuery("#telephone").removeAttr("data-parsley-excluded");                                              
      } else {                
        jQuery("#telephone").attr("data-parsley-excluded","true");            
        
      }
    });
    // Par defaut pas de validation sur le telephone
    jQuery("#telephone").attr("data-parsley-excluded","true");            
    //jQuery("#telephone").removeAttr("data-parsley-required");              
    //jQuery("#telephone").removeAttr("required");   

    // Gestion de l'étape Date de naissance selon clic "Moins de 1 an" ou pas
    jQuery("#step_age_enfant_le_plus_jeune").on("form-step-next-change",function(event,options) {
      if (jQuery("#age_enfant19").prop("checked") || jQuery("#age_enfant1").prop("checked") || jQuery("#age_enfant2").prop("checked")) {
          // Désactive la validation de la date de naissance
          jQuery("#date_naissance").removeAttr("data-parsley-required");              
          jQuery("#date_naissance").removeAttr("required");              
          //Saute l'étape Date de naissance   
          var indexEtapeCoordonne = jQuery(".acf-steps .step-form").index(jQuery("#step_coordonnees"));                                                      
          options = {'stepIndex' : indexEtapeCoordonne};                   
      } else {
          // Active la validation de la date de naissance
          jQuery("#date_naissance").attr("data-parsley-required","true");                          
      }
      return options;
    });

    // Capte le retour sur l'étape Coordonnée
    jQuery("#step_coordonnees").on("form-step-prev-changed", function() {
     if (jQuery("#age_enfant19").prop("checked") || jQuery("#age_enfant1").prop("checked") || jQuery("#age_enfant2").prop("checked")) {
          //Saute l'étape Date de naissance                                                         
          var indexEtapeAgeEnfant = jQuery(".acf-steps .step-form").index(jQuery("#step_age_enfant_le_plus_jeune"));                                                      
          Kinougarde.formulaireAcf.NextStep({'stepIndex' : indexEtapeAgeEnfant});          
      }
    });

    // Capte le click sur "Envoyer" de la dernière étape
    // Avant le changement le passage à la confirmation
      jQuery('#step_jeux_concours').on('form-step-next-change',function(event,options) {                       
        //Modifie les options par défaut qui seront utilisés pour le passage à l'étape suivante
        var indexEtapeFin = jQuery(".acf-steps .step-form").index(jQuery("#step_confirmation"));
        options = {'action':'jeux_concours','stepIndex' : indexEtapeFin,'data': {'date_debut_concours' : jQuery("#date_debut_concours").val(),'id_partner': jQuery("#id_partner").val()}};            
        return options;            
    });

    
    // Capte le résultat après un click sur "Envoyer"  
    jQuery("#step_jeux_concours").on("form-step-next-changed", function(e,reponse,data) {            
      try {
        // Mise à jour des infos de l'agence
        w.Kinougarde.UpdateAgence(reponse.data.Agence);        
       //loadAgencyData(reponse.data.IdAgence);
        // Mémorise les données du formulaire pour une prochaine utilisation
        // se base sur le consentement de l'utilisateur
        Kinougarde.SetStorage("form-jeux-concours",data);            
      }
      catch (e) {
      }
    });
                                          
  };
  
  /**
   * 
   * @param {*} codeNatureOffreGe 
   */
   w.Kinougarde.JeuxConcours.toogleEstDesservie = function(data) {
    try {                            
        
    if (data.CodeNatureOffreGe===1) {
        // Zone non desservie pour la garde d'enfant
       $("#step_jeux_concours .hideifnondesservie").hide();              
      }
    else if (data.CodeNatureOffreGe===2 && (jQuery("#age_enfant18").prop("checked") || jQuery("#age_enfant19").prop("checked")))  {
      //Zone non désservie pour les moins de trois ans
      $("#step_jeux_concours .hideifnondesservie").hide();              
    }
    else {
        // Zone desservie
        $("#step_jeux_concours .hideifnondesservie").show();        
     }
    
    }
    catch(e) {

    }

}

})(window);

jQuery(function() {
  try {
    if (jQuery("#section-jeux-concours").length>0) {               
        Kinougarde.JeuxConcours.initFormulaireJeuxConcours();                       
    }   
  }     
  catch (ex) {
      console.error(ex);
  }
});
    